import BaseClient from './BaseClient';
import { forCondition } from '../hooks/ForCondition';
import { formatDate } from '@app/utilities';
import { addDays } from 'date-fns';

const EOD_TERMINAL_FAILURE_STATES = ['Failed'];
const EOD_TERMINAL_STATES = ['Completed', 'Suppressed', ...EOD_TERMINAL_FAILURE_STATES];

export default class EodoServiceClient extends BaseClient {
  constructor(billingDate = null, tenantId: string) {
    super(billingDate, tenantId, true, "ams");
  }

  public async triggerEod(accountId: string, endOfDayDate: Date): Promise<void> {
    const endOfDay = formatDate(endOfDayDate, 'yyyy-MM-dd');
    
    this._billingDate = addDays(endOfDayDate, 1);
    this._billingDate.setUTCHours(0, 0, 0, 0);

    const response = await this.post(`/api/proxy/ams/eodo-service/account/${accountId}/start-end-of-day`, {
      endOfDayDate: endOfDay,
    });

    if (response.status >= 400) {
      throw new Error(`Failed to trigger EOD for ${endOfDay}: HTTP ${response.status}`);
    }
  }

  public async getEodView(accountId: string, endOfDayDate: Date): Promise<any> {
    const response = await this.get(
      `/api/proxy/ams/eodo-service/account/${accountId}/eod?endOfDayDate=${formatDate(endOfDayDate, 'yyyy-MM-dd')}`
    );
    return await this.handleResponse<any>(response);
  }

  public async waitForEodCompletion(accountId: string, endOfDayDate: Date): Promise<void> {
    const value = await forCondition(
      () => this.getEodView(accountId, endOfDayDate),
      (eodView) => eodView?.state != null && EOD_TERMINAL_STATES.includes(eodView.state)
    );

    if (EOD_TERMINAL_FAILURE_STATES.includes(value?.state)) {
      throw new Error(`EOD ${value.state} for ${formatDate(endOfDayDate, 'yyyy-MM-dd')}`);
    }
  }
}

export const useEodoService = (billingDate = null, tenantId: string): EodoServiceClient => {
  return new EodoServiceClient(billingDate, tenantId);
};
